import React, { Component } from 'react';

class Failure extends Component {
  render() {
    return (
      <div className="status-outline">
        <div className="usa-alert usa-alert-error">
          <div className="usa-alert-body">
            <h3 className="usa-alert-heading">Login Failed</h3>
            <p className="usa-alert-text">
              { this.props.error }
            </p>
            <p className="usa-alert-text">
	      <b>{ this.props.explanation }</b>
            </p>
          </div>
        </div>
        <button onClick={ this.props.onTryAgain }>Try Again</button>
      </div>
    );
  }
}

export default Failure;



// WEBPACK FOOTER //
// ./src/Failure.jsx